"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _default;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _loadScript = _interopRequireDefault(require("./loadScript"));

function _default() {
  if (window.fetch) {
    return _promise.default.resolve(window.fetch);
  }

  return (0, _loadScript.default)('https://cdn.staticsfly.com/gbundles/cdn/whatwg-fetch-2.0.4.js').then(function () {
    return window.fetch;
  });
}